$(document).ready(function() {
  $('.product-variant-picker-block').each(function() {
  var get_selected_var = $(this).find('input:checked').val();
    var get_image = $(this).find('input:checked').attr('data-swatch-image');
    // console.log('checked value = '+get_selected_var);
    $(this).find('.selected_value').html(get_selected_var);
    $(this).find('.swatch_image').html('<img src="'+get_image+'" />');
    if($(this).find('input:checked').attr('data-swatch-image')) {
      $(this).find('.swatch_image').show();
    }
    else {
      $(this).find('.swatch_image').hide();
    }
    });

  $(document).on('click','.product-variant-picker-block .variant-input input',function() {
    console.log('click');
    // $('.selected_value').html('');
    var get_selected_value = $(this).val();
    var get_image = $(this).attr('data-swatch-image');
    console.log('get_selected_value = '+get_selected_value);
    $(this).closest('.product-variant-picker-block').find('.selected_value').html(get_selected_value);
    $(this).closest('.product-variant-picker-block').find('.swatch_image').html('<img src="'+get_image+'" />');
    if($(this).attr('data-swatch-image')) {
      console.log('has attribute');
      $(this).closest('.product-variant-picker-block').find('.swatch_image').show();
    }
    else {
      console.log('no attribute');
      if(get_selected_value == "Custom Size"){
        $(".extra-custom-msg").show();
        $(".product-price-block").hide();
      }
      else{
            $(".extra-custom-msg").hide();
        $(".product-price-block").show();
      }
      $(this).closest('.product-variant-picker-block').find('.swatch_image').hide();
    }
  });
});